import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { LanguageService } from '../core/services/language.service';
import { TranslateModule } from '@ngx-translate/core';

import { PagesRoutingModule } from "./pages-routing.module";
import { SharedModule } from '../shared/shared.module';
import { PipedriveComponent } from './pipedrive/pipedrive.component';

@NgModule({
  declarations: [
    PipedriveComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    TranslateModule,
    ReactiveFormsModule
  ],
  providers: [LanguageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PagesModule {
  constructor() {
    
  }
 }
